import { useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

export default function FinishingSetup() {
    const { session } = useAuth();
    const navigate = useNavigate();
    const [error, setError] = useState(false);

    useEffect(() => {
        let attempts = 0;
        const interval = setInterval(async () => {
            attempts++;
            const res = await fetch(
                `${process.env.REACT_APP_BACKEND_URL}/api/supabase/studios/me`,
                {
                    headers: {
                        Authorization: `Bearer ${session?.access_token}`,
                    },
                }
            );
            if (res.ok) {
                const studio = await res.json();
                if (studio.is_active) {
                    clearInterval(interval);
                    navigate('/app/dashboard');
                }
            }
            if (attempts >= 5) {
                clearInterval(interval);
                setError(true);
            }
        }, 2000);
        return () => clearInterval(interval);
    }, [session, navigate]);

    const handleRetry = () => {
        setError(false);
        window.location.reload();
    };

    return (
        <div className="flex h-screen items-center justify-center">
            <div className="flex flex-col items-center">
                <div className="flex justify-center mb-4">
                    <svg
                        className="animate-spin h-8 w-8 text-indigo-600"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                    >
                        <circle
                            className="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            strokeWidth="4"
                        ></circle>
                        <path
                            className="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8v8z"
                        ></path>
                    </svg>
                </div>
                <div className="text-lg font-bold mb-2">Finishing setup...</div>
                <div className="text-gray-500 mb-2">
                    This may take a few seconds. Please wait.
                </div>
                {error && (
                    <div className="flex flex-col items-center">
                        <div className="text-red-600 mb-2">
                            Still waiting for confirmation from Stripe. Please
                            try again.
                        </div>
                        <button
                            onClick={handleRetry}
                            className="px-4 py-2 bg-indigo-600 text-white rounded hover:bg-indigo-700"
                        >
                            Retry
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
}
